import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=b6e4deea&scoped=true&"
var script = {}
import style0 from "./SideBar.vue?vue&type=style&index=0&id=b6e4deea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e4deea",
  null
  
)

export default component.exports